import axios from 'axios';
import { stripStringForHtml } from '../sharedJs/utilityFunctions';
import {
    FEEDBACKBAR_RESET, FEEDBACKBAR_SEND_FEEDBACK, FEEDBACKBAR_SET_ISOPEN,
    FEEDBACKBAR_POST_FEEDBACK_MESSAGE, FEEDBACKBAR_SET_ISLOADING
} from './types';

export const resetState = () => (dispatch) => {
    dispatch({
        type: FEEDBACKBAR_RESET,
        payload: true
    });
};

export const setFeedbackBarOpen = isOpen => (dispatch) => {
    dispatch({
        type: FEEDBACKBAR_SET_ISOPEN,
        payload: isOpen
    });
};

const dispatchFeedbackTypeSent = type => (
    {
        type: FEEDBACKBAR_SEND_FEEDBACK,
        payload: type
    }
);

export const sendFeedbackType = (type, pageInfo) => (dispatch) => {
    dispatch({
        type: FEEDBACKBAR_SET_ISLOADING,
        payload: true
    });
    // TODO: Change url below to real api endpoint
    axios.post('http://www.mocky.io/v2/5b891abe300000f70e33830d?mocky-delay=80ms', {
        feedbackType: type,
        ...pageInfo
    })
        .then(() => {
            dispatch(dispatchFeedbackTypeSent(type));
        })
        .catch((error) => {
            throw error;
        });
};

const dispatchFeedbackMessagePosted = postSuccess => (
    {
        type: FEEDBACKBAR_POST_FEEDBACK_MESSAGE,
        payload: postSuccess
    }
);

export const postFeedbackMessage = (userName, email, message, pageInfo) => (dispatch) => {
    dispatch({
        type: FEEDBACKBAR_SET_ISLOADING,
        payload: true
    });
    // TODO: Change url below to real api endpoint
    axios.post('http://www.mocky.io/v2/5b891abe300000f70e33830d?mocky-delay=1500ms', {
        name: stripStringForHtml(userName),
        email: stripStringForHtml(email),
        message: stripStringForHtml(message),
        ...pageInfo
    })
        .then(() => {
            dispatch(dispatchFeedbackMessagePosted(true));
        })
        .catch((error) => {
            throw error;
        });
};
